<template>
  <div>
    <section role="form">
      <div class="main-container container container-top">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-default">
              <div class="card-content">
                <h4>Avaliados</h4>
                <div>
                  <table class="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>Nome</th>
                        <th class="hidden-xs">Notas Atribuídas</th>
                        <th class="hidden-xs">Situação</th>
                        <th>&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="periodo in periodosOrdenados"
                        :key="periodo.id"
                        :class="situacaoPendente(periodo, 'class')"
                      >
                        <td>{{ periodo.avaliado.pessoa.nome }}</td>
                        <td class="hidden-xs">{{ mostraNota(periodo) }}</td>
                        <td class="hidden-xs">
                          {{
                            situacaoAtual(periodo)
                              ? 'EM ANDAMENTO'
                              : 'FINALIZADA'
                          }}
                        </td>
                        <td class="td-btns td-btns-alone">
                          <botao
                            :estilo="situacaoPendente(periodo, 'estilo')"
                            :icone="
                              situacaoAtual(periodo)
                                ? 'editar-tabela'
                                : 'visualizar'
                            "
                            @clicado="editaAvaliacao(periodo.avaliado.id)"
                          >
                          </botao>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="col-xs-12 footer-controller-inner">
                    <botao
                      estilo="vazado-verde-esq"
                      rotulo="Voltar"
                      icone="voltar"
                      @clicado="volta()"
                    ></botao>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Botao from '@/components/botao';
import PeriodoAtualHelper from '@/helpers/PeriodoAtualHelper';
import ArrayHelper from '@/helpers/ArrayHelper';

export default {
  name: 'Avaliados',

  data() {
    return {
      apiErrors: null,
      funcionarioId: this.$route.params.idAvaliador,
      periodos: [],
    };
  },

  computed: {
    periodosOrdenados() {
      this.periodos.forEach(
        periodo => (periodo.nomeAvaliado = periodo.avaliado.pessoa.nome),
      );

      return this.periodos.sort(ArrayHelper.compareValues('nomeAvaliado'));
    },
  },

  methods: {
    situacaoAtual(periodo) {
      const {
        dataInicioLancamento,
        dataFimLancamento,
      } = periodo.competencia.periodos[0];

      const estahDentroDoPeriodo = PeriodoAtualHelper.validaPeriodo(
        dataInicioLancamento,
        dataFimLancamento,
      );
      const naoAceitouNemRecusou = periodo.aceita == null;
      const naoEstahEmEstagioProbatorio = periodo.mediaEstagioProbatorio == 0;

      return (
        estahDentroDoPeriodo &&
        naoAceitouNemRecusou &&
        naoEstahEmEstagioProbatorio
      );
    },
    mostraNota(periodo) {
      if (periodo.mediaEstagioProbatorio > 0) {
        return periodo.mediaEstagioProbatorio;
      }
      if (periodo.avaliado.id == this.funcionarioId) {
        return periodo.totalAutoavaliacao;
      }
      return periodo.totalAvaliador;
    },
    situacaoPendente(periodo, atributoQueMuda) {
      if (periodo.mediaEstagioProbatorio > 0) {
        return atributoQueMuda === 'class' ? '' : 'vazado-cinza-sm';
      }
      if (
        periodo.avaliado.id == this.funcionarioId &&
        periodo.totalAutoavaliacao == 0
      ) {
        return atributoQueMuda === 'class'
          ? 'situacao-pendente'
          : 'vazado-laranja-sm';
      }
      if (
        periodo.avaliado.id != this.funcionarioId &&
        periodo.totalAvaliador == 0
      ) {
        return atributoQueMuda === 'class'
          ? 'situacao-pendente'
          : 'vazado-laranja-sm';
      }
      return atributoQueMuda === 'class' ? '' : 'vazado-cinza-sm';
    },
    editaAvaliacao(avaliadoId) {
      this.$router.push({
        name: 'DetalhaAvaliacao',
        params: { idAvaliador: this.funcionarioId, idAvaliado: avaliadoId },
      });
    },
    volta() {
      this.$router.push({ name: 'Avaliacao' });
    },
  },

  created() {
    this.periodos = JSON.parse(sessionStorage.getItem('periodos'));
  },

  mounted() {
    window.scrollTo(0, 0);
  },

  components: {
    botao: Botao,
  },
};
</script>



// WEBPACK FOOTER //
// avaliados.vue?5c25607b